export default {
  state: {
    /**
     *描述：keep-alive 缓存组件名称
     *版本：1.0
     */
    keepInclude: [],
    /**
     *描述：移动应用程序存储所有变量对象
     *版本：1.0
     */
    ApplicationData: {}
  },
  getters: {

  },
  mutations: {
    /**
     *描述：删除缓存组件名称
     *版本：1.0
     */
    removeKeepInclude(state, ComponentName) {
      const index = state.keepInclude.indexOf(ComponentName);
      if (index !== -1) {
        const compont = state.remoteComponentVersion.find((item) => item.componentName === ComponentName);
        if (compont) {
          if (compont.cacheStatus === "0") { // 不缓存
            state.keepInclude.splice(index, 1);
          }
        }
      }
    },
    /**
     *描述：增加缓存组件名称
     *版本：1.0
     */
    setKeepInclude(state, ComponentName) {
      let addState = false;
      for (let i = state.keepInclude.length - 1;i >= 0;i--) {
        if (state.keepInclude[i] === ComponentName) {
          addState = true;
          i = 0;
        }
      }
      if (!addState) {
        state.keepInclude.push(ComponentName);
      }
    },
    /**
     *描述：设置移动应用程序存储变量对象
     *版本：1.0
     */
    setApplicationData(state, obj) {
      state.ApplicationData[obj.key] = obj.value;
    }
  },
  actions: {

  }
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js